<template>
  <section class="showroom-form">
    <embed-frame
      class="showroom-form-frame"
      endpoint="public_simulator_settings/form"
      placeholder="Carregando..."
      :settings="embedSettings"
      :callbacks="embedCallbacks"
    />
  </section>
</template>

<script>
  /* eslint no-underscore-dangle: ['error', { allow: ['_enable_meta_connections'] }] */

  import EmbedFrame from '@sdk/views/Embed/Frame.vue';

  export default {
    name: 'ShowroomForm',
    components: {
      EmbedFrame,
    },
    computed: {
      embedSettings() {
        return {
          public_simulator_settings: {
            form: {
              store_id: this.$route.params.id,
              // Beta escape hatch for the Eita-only Meta connections gate: with
              // `?_enable_meta_connections=true` on the URL, the embed opens the
              // connections block to any role (see embed Showroom/Form.vue). The
              // server still enforces the real guard (Store :update permission).
              _enable_meta_connections: this.$route.query._enable_meta_connections === 'true',
            },
          },
        };
      },
      embedCallbacks() {
        return {
          'public_simulator_setting:create': this.callback,
          'public_simulator_setting:update': this.callback,
        };
      },
    },
    methods: {
      callback() {
        this.$router.push({
          name: 'stores-public-simulator-settings-list',
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .showroom-form {
    padding: 0 var(--product--pwa--horizontal);

    @media all and (max-width: $cordel-breakpoint-mobile) {
      padding: 0 var(--product--pwa--horizontal);
    }
  }
</style>
